import { removeSpaces } from './utils';

export const getIBAN = (
  bban: string,
  friendlyFormat = true,
  countryCode = 'NL',
  bankCode = 'RABO',
): string => {
  const paddedBBAN = removeSpaces(bban).padStart(10, '0');
  const controlNumber = getControlNumber(
    `${bankCode}${paddedBBAN}${countryCode}00`,
  );
  const unformattedIban = `${countryCode}${controlNumber}${bankCode}${paddedBBAN}`;
  return friendlyFormat ? formatIBAN(unformattedIban) : unformattedIban;
};

export const isValidBBAN = (bban: string): boolean => {
  return /^\d{9}$/.test(bban);
};

const formatIBAN = (iban: string): string => {
  return iban.match(/.{1,4}/g).join(' ');
};

const getControlNumber = (invertedIBAN: string): string => {
  const checksum = mod9710Iban(invertedIBAN);
  const controlNumber = 98 - checksum;
  const paddedControlNumber = String(controlNumber).padStart(2, '0');
  return paddedControlNumber;
};

const replaceLettersByNumbers = (str: string): string => {
  // As explained here: https://www.iban.nl/iban/iban-controle-mod-97-berekening/
  return str
    .split('')
    .map((char) => {
      const charCode = char.charCodeAt(0);
      if (charCode >= 65) {
        // Replace letters by 2 numbers, where A = 10, B = 11, …, Z = 35 etc
        return (charCode - 55).toString();
      }
      return char; // Leave numbers unchanged
    })
    .join('');
};

const mod9710Iban = (invertedIBAN: string): number => {
  // Provide an IBAN with the first 4 characters moved to the end
  let validationString = replaceLettersByNumbers(invertedIBAN);
  while (validationString.length > 2) {
    const part = validationString.slice(0, 6);
    const partInt = parseInt(part, 10);
    if (isNaN(partInt)) {
      return NaN;
    }
    validationString =
      String(partInt % 97) + validationString.slice(part.length);
  }
  return parseInt(validationString, 10) % 97;
};
